<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="!tickets.length && errors" @tryAgain="getTickets" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <div
                class="flex flex-col md:flex-row justify-between items-center md:items-center mb-6 lg:mb-8">
                <h3 class="flex items-center md:text-26 text-2xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('Support ticket') }}
                </h3>
                <div class="flex mt-6 md:mt-0 flex-col lg:flex-row w-full md:w-auto justify-end">
                    <div class="flex mt-4 lg:mt-0 justify-end">
                        <input
                            class="input w-full h-10 xl:pl-36 placeholder-gray-320 md:w-64 xl:w-80 ml-2 bg-gray-350 bg-opacity-10 rounded-lg  transition duration-200 text-sm text-gray-350 px-3 font-medium dark:!bg-base-300 dark:!text-white  focus:bg-blue-700 focus:bg-opacity-10 border border-blue-700  focus:border-opacity-100"
                            type="text" :placeholder="__('Search...')" v-model="searchValue">
                        <button @click="search"
                            class="bg-blue-600 disabled:opacity-70 disabled:!bg-blue-600 flex items-center h-10 md:px-5 px-3 rounded-md text-white font-semibold text-sm transition duration-200 hover:bg-blue-800 ">
                            {{ __('Search') }}
                        </button>
                    </div>
                    <div class="flex justify-end order-first lg:order-last lg:mr-4">
                        <router-link :to="{name: 'user.ticket.create'}" class="btn btn-outline btn-info btn-base">
                            <span class="mt-0.5">{{ __('Add ticket') }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="rounded-2xl dark:bg-base-300 bg-white">
                <div class=" overflow-x-auto">
                    <table class="table table-xs md:table-sm xl:table-md" v-if="tickets.length">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th> {{ __('Subject') }} </th>
                                <th> {{ __('User') }} </th>
                                <th> {{ __('Priority') }} </th>
                                <th> {{ __('Status') }} </th>
                                <th> {{ __('Latest update') }} </th>
                                <th> {{ __('Action') }} </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in tickets">
                                <td> {{ (meta.per_page * (meta.current_page - 1)) + index + 1 }} </td>
                                <td> {{ item.subject }} </td>
                                <td> {{ item.user || '---' }} </td>
                                <td> {{ __(item.priority.capitalize()) }} </td>
                                <td :class="{'text-info': item.status == 'open','text-warning': item.status == 'progress','text-success': item.status == 'answered','text-danger': item.status == 'closed'}"> {{ __(item.status.capitalize()) }} </td>
                                <td> {{ item.updated_at }}</td>
                                <td>
                                    <router-link :to="{name: 'user.ticket.show',params: {id: item.id}}"
                                        class="btn btn-outline btn-primary btn-sm">
                                        {{ __('detail') }}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
                        <NotFound />
                    </div>
                </div>
            </div>
            <Pagination :meta="meta" @setPage="setPage" class="!mt-6" />
        </div>
    </div>

</template>
<script setup>
import { ref, onMounted, computed } from 'vue';

const { getTickets,tickets, loading, errors, meta, router, route, loadingBtn } = useDashboard();
const searchValue = ref(route.query.search || '');
const setQuery = (key, value) => {
    getTickets(window.setQuery(router, route, key, value));
}
const setPage = (p) => {
    setQuery('page', p.toString());
};

const search = () => {
    setQuery('search', searchValue.value)
}
onMounted(() => {
    getTickets(route.query);
});
</script>